export const groupBy = (arr, key) => arr.reduce((groups, item) => {
    var _a;
    (groups[_a = key(item)] || (groups[_a] = [])).push(item);
    return groups;
}, {});
export function removeDuplicates(array) {
    return [...new Set(array)];
}
export function randomRangeF(min, max) {
    return Math.random() * (max - min) + min;
}
export function normalized(vec2D) {
    let directionLength = Math.sqrt(vec2D[0] * vec2D[0] + vec2D[1] * vec2D[1]);
    return [vec2D[0] / directionLength, vec2D[1] / directionLength];
}
export function angleFromDirection(vec2D) {
    let sign = vec2D[1] < 0 ? (-1) : 1;
    return sign * Math.acos(vec2D[0]);
}
